/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classNames from 'classnames';
import SuccessDarkIcon from './successDarkIcon.svg';
import ErrorDarkIcon from './errorDarkIcon.svg';
import { StyledDarkStatus } from './darkStatusStyles';
import { useIntl } from 'react-intl';
export var DarkStatus = function DarkStatus(props) {
  var children = props.children,
    type = props.type,
    className = props.className;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(StyledDarkStatus, {
    className: classNames({
      'EmbersDarkStatus-root': true
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersDarkStatus-icon"
  }, /*#__PURE__*/React.createElement("img", {
    className: type === 'success' ? 'EmbersDarkStatus-icon-success' : 'EmbersDarkStatus-icon-error',
    src: type === 'success' ? SuccessDarkIcon : ErrorDarkIcon,
    alt: type === 'success' ? intl.formatMessage({
      id: 'embers.statusIcon.success',
      defaultMessage: 'success'
    }) : intl.formatMessage({
      id: 'embers.statusIcon.error',
      defaultMessage: 'error'
    })
  })), children);
};